import {FinancingCompositionScene} from '@dms/api/shared';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {CompositionEditorMode} from '../types/CompositionEditorMode';

// A financing card is shown on its own in the gallery and on portals, so it starts opaque white;
// a watermark is drawn over the vehicle photo, so it starts transparent.
const FINANCING_DEFAULT_BACKGROUND: FinancingCompositionScene['canvas']['background'] = {
  color: '#FFFFFF',
  opacity: 1,
};

export const createDefaultScene = (mode: CompositionEditorMode): FinancingCompositionScene => ({
  version: 1,
  canvas: {
    width: compositionEditorLimits.defaultCanvasWidth,
    height: compositionEditorLimits.defaultCanvasHeight,
    background: mode === 'financing' ? FINANCING_DEFAULT_BACKGROUND : null,
  },
  layers: [],
});
